import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import { propChildren, propFunc, propStr, } from '../../../../helpers/custom-prop-types';
import { scrollToTarget } from '../../../../helpers/ScrollUtils';
const AboutAccordion = (props) => {
    const { buttonClassName, children, closeText, keyId, onChange, openText } = props;
    const onChangeWrap = (e) => {
        if (onChange) {
            onChange(e);
        }
        if (!e.currentTarget.checked) {
            scrollToTarget(`${keyId}-title`);
        }
    };
    return (_jsxs("div", Object.assign({ className: 'about-accordion' }, { children: [_jsx("input", { id: keyId, onChange: onChangeWrap, type: 'checkbox' }), _jsx("label", Object.assign({ className: `about-accordion-button ${buttonClassName}`, htmlFor: keyId }, { children: _jsx("span", Object.assign({ className: 'openText' }, { children: openText })) })), _jsx("div", Object.assign({ className: 'about-accordion-child' }, { children: children })), _jsx("label", Object.assign({ className: `about-accordion-button ${buttonClassName}`, htmlFor: keyId }, { children: _jsx("span", Object.assign({ className: 'closeText' }, { children: closeText })) }))] })));
};
AboutAccordion.propTypes = {
    buttonClassName: propStr(),
    children: propChildren().isRequired,
    closeText: propStr(),
    keyId: propStr().isRequired,
    onChange: propFunc(),
    openText: propStr(),
};
AboutAccordion.defaultProps = {
    buttonClassName: '',
    closeText: 'close',
    onChange: undefined,
    openText: 'detail',
};
export default AboutAccordion;
